import styled from 'styled-components';

const BrandLabel = styled.p`
  font-weight: bold;
  font-size: 3rem;
  font-family: HCA-Mark-Bold;
`;

const LoginForm = styled.div`
  width: 16em;
`;

const LoginContainer = styled.div`
  background-color: #f6f6f6;
  height: 100vh;
`;

export { BrandLabel, LoginContainer, LoginForm };
